import { useSelector } from 'react-redux'
import { IStore } from '../interfaces/Store'
import { getRevisitSteps, isJourneyRevisit } from '../services/utils'
import { IBreadCrumb } from '../interfaces/Breadcrumb'

const useSidebarHook = (): { navigation: IBreadCrumb[]; step: number } => {
  const { breadcrumb, step } = useSelector(
    (state: IStore) => state.breadcrumbReducer
  )

  const journeyStatus = useSelector(
    (state: IStore) => state.folderReducer.folder.journeyStatus
  )
  const isMediumOrLowRisk = useSelector(
    (store: IStore) => store.folderReducer.isMediumOrLowRisk
  )

  let navigation = breadcrumb

  if (isJourneyRevisit(journeyStatus)) {
    navigation = getRevisitSteps(breadcrumb)
  }

  if (isMediumOrLowRisk) {
    navigation = navigation.filter((item) => item.titre !== 'Patrimoine')
  }

  const currentStep = navigation.findIndex(
    (item: IBreadCrumb) => item.titre === breadcrumb[step]?.titre
  )

  return { navigation, step: currentStep }
}

export default useSidebarHook
